import React, { useMemo } from 'react';
import Select from 'fe-design-base/atoms/Select';
import Text from 'fe-design-base/atoms/Text';
import PropTypes from 'prop-types';

import { WEEKDAYS, WEEKENDS } from './constants';

const DaySelectInput = ({
  payrollDays,
  weekdaysOnly,
  firstDayOfTheWeek = 'sunday',
  ...props
}) => {
  const days = useMemo(() => {
    const labelText = payrollDays
      ? 'settings.pages.payroll.payday.days'
      : 'date.day_names';

    const daysIndices = [...WEEKDAYS.keys()];

    let firstDayOfTheWeekIndex = WEEKDAYS.indexOf(
      firstDayOfTheWeek.toLowerCase()
    );

    // default to sunday if the firstDayOfTheWeek is an invalid week day
    if (firstDayOfTheWeekIndex === -1) firstDayOfTheWeekIndex = 0;

    return [
      ...daysIndices.slice(firstDayOfTheWeekIndex, 7),
      ...daysIndices.slice(0, firstDayOfTheWeekIndex),
    ].map(i => ({
      value: i,
      label: <Text i18n={`${labelText}.${i}`} />,
    }));
  }, [firstDayOfTheWeek, payrollDays]);

  const dayOptions = useMemo(
    () =>
      weekdaysOnly ? days.filter(item => !WEEKENDS.includes(item.value)) : days,
    [weekdaysOnly, days]
  );

  return <Select {...props} options={dayOptions} />;
};

DaySelectInput.propTypes = {
  weekdaysOnly: PropTypes.bool,
  payrollDays: PropTypes.bool,
};

export default DaySelectInput;
